import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const fullGridColumn = () => ({
    "breakpoint.base": "col-start / span 4",
    "breakpoint.md": "col-start 2 / span 6",
    "breakpoint.xl": "col-start 3 / span 8",
    "breakpoint.xxxl": "col-start 4 / span 6",
});
export const subGridColumn = (type, index) => {
    if (type === "full") {
        return "col-start / span 6";
    }
    else if (index === 0) {
        return "col-start / span 3";
    }
    else {
        return "span 3 / span 6";
    }
};
// reference https://zeroheight.com/626199550/p/532346-grids-and-breakpoints
export const BASE_BREAKPOINTS = {
    XXS: 0,
    XS: 360,
    SM: 600,
    MD: 768,
    LG: 1024,
    XL: 1280,
    XXL: 1536,
    XXXL: 1920,
};
export const MasonryWrapper = ({ children, testId, imagesCount, }) => (_jsx(Box, { as: "main", display: "grid", gridTemplateColumns: {
        "breakpoint.base": "repeat(4, [col-start] 1fr)",
        "breakpoint.md": "repeat(8, [col-start] 1fr)",
        "breakpoint.xl": "repeat(12, [col-start] 1fr)",
    }, gridTemplateRows: `repeat(${imagesCount})`, rowGap: "spacing.8", columnGap: {
        "breakpoint.base": "spacing.16",
        "breakpoint.xl": "spacing.24",
    }, maxWidth: {
        "breakpoint.sm": BASE_BREAKPOINTS.SM,
        "breakpoint.md": BASE_BREAKPOINTS.MD,
        "breakpoint.lg": BASE_BREAKPOINTS.LG,
        "breakpoint.xl": BASE_BREAKPOINTS.XL,
        "breakpoint.xxl": BASE_BREAKPOINTS.XXL,
        "breakpoint.xxxl": BASE_BREAKPOINTS.XXXL,
    }, paddingHorizontal: {
        "breakpoint.md": "spacing.32",
        "breakpoint.xl": "spacing.80",
    }, marginHorizontal: "auto", paddingBottom: "spacing.32", marginBottom: {
        "breakpoint.base": "spacing.64",
        "breakpoint.md": "spacing.none",
    }, testId: testId, width: "100%", children: children }));
export const MasonryContainer = ({ children }) => (_jsx(Box, { display: "grid", gridColumn: fullGridColumn(), gridTemplateColumns: "repeat(6,[col-start] 1fr)", paddingHorizontal: {
        "breakpoint.xxl": "86px",
        "breakpoint.xxxl": "65px",
    }, gap: "spacing.8", children: children }));
export const MasonryPictureUI = ({ children, id }) => (_jsx(Box, { as: "picture", objectPosition: "center", cursor: "pointer", id: id, children: children }));
